export const MEDICAL_LICENSE_NAME = 'MEDICAL';
